import request from '../../../../../api/request';
import { AssignedStudentModalFormData, FormDataResponse } from './types';

export const ASSIGNED_STUDENTS = {
  FORM_DATA:
    '/maintainers-portal/management-tools/teacher-file-assigned-students/form-data',
  GET_STUDENTS: () =>
    '/maintainers-portal/management-tools/teacher-file-assigned-students/students',
  GET_STUDENTS_BY_TEACHER: (teacherId: string | number) =>
    `/maintainers-portal/management-tools/teacher-file-assigned-students/${teacherId}/students`,
  POST_ASSIGNED_STUDENTS: (teacherId: string | number) =>
    `/maintainers-portal/management-tools/teacher-file-assigned-students/${teacherId}/assign-student`,
  DELETE_ASSIGNED_STUDENTS: (teacherId: string | number) =>
    `/maintainers-portal/management-tools/teacher-file-assigned-students/${teacherId}/deassign-students`,
  GET_REPORT: (teacherId: string | number) =>
    `/maintainers-portal/management-tools/teacher-file-assigned-students/${teacherId}/report`,
};
export function getAssignedStudentsFormData() {
  return request<FormDataResponse>(ASSIGNED_STUDENTS.FORM_DATA);
}

export function getAllStudentsFormData(searchText?: string) {
  return request<AssignedStudentModalFormData[]>(
    ASSIGNED_STUDENTS.GET_STUDENTS(),
    {
      params: { search_text: searchText },
    },
  );
}

export function getAssignedStudents(filters: any, teacherId: string | number) {
  return request<any>(ASSIGNED_STUDENTS.GET_STUDENTS_BY_TEACHER(teacherId), {
    params: filters,
  });
}

export async function getReport(teacherId: string | number, filters: any) {
  return request<Blob>(ASSIGNED_STUDENTS.GET_REPORT(teacherId), {
    data: filters,
    method: 'POST',
    responseType: 'blob',
  });
}

export async function addTutor(
  teacherId: string | number,
  data: { studyPlanEnrollmentId: number },
) {
  return request<Blob>(ASSIGNED_STUDENTS.POST_ASSIGNED_STUDENTS(teacherId), {
    data,
    method: 'POST',
  });
}

export async function removeTutors(
  teacherId: string | number,
  data: { studyPlanEnrollmentIds: number[] },
) {
  return request<boolean>(
    ASSIGNED_STUDENTS.DELETE_ASSIGNED_STUDENTS(teacherId),
    {
      data,
      method: 'DELETE',
    },
  );
}
